/**
 * @desc labelList
 */

import './labelList.scss';
import React from 'react';
import classNames from 'classnames';

export default function LabelList({ className, children, ...others }) {

    return (
        <div className={classNames('label-list', className)} {...others}>
            { children }
        </div>
    );
}

LabelList.Item = function ({ label = '', className, children, ...others }) {
    return (
        <div className={classNames('label-list-item', className)} {...others}>
            <div className="label-list-item-label">{ label ? <label>{label}</label> : null }</div>
            <div className="label-list-item-content">{children}</div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/labelList/LabelList.jsx